/**
 * Debug Utility
 * Globally intercepts console.log calls to only show when ?debug=true is in the URL
 */

// Check if debug mode is enabled (only check once)
const isDebugMode = (() => {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('debug') === 'true';
})();

// Store original console methods
const originalConsole = {
  log: console.log,
  warn: console.warn,
  error: console.error,
  info: console.info
};

// Override console methods globally
if (!isDebugMode) {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  // Keep console.error always visible for important errors
}

// Debug logger that only logs when debug=true
export const debug = {
  log: (...args) => {
    if (isDebugMode) {
      originalConsole.log(...args);
    }
  },
  warn: (...args) => {
    if (isDebugMode) {
      originalConsole.warn(...args);
    }
  },
  error: (...args) => {
    originalConsole.error(...args);
  },
  info: (...args) => {
    if (isDebugMode) {
      originalConsole.info(...args);
    }
  },
  // Check if debug mode is enabled
  enabled: isDebugMode,
  // Restore original console methods if needed
  restore: () => {
    console.log = originalConsole.log;
    console.warn = originalConsole.warn;
    console.error = originalConsole.error;
    console.info = originalConsole.info;
  }
};

export default debug;